import { render, staticRenderFns } from "./ImportPayments.vue?vue&type=template&id=a0c64526&scoped=true"
import script from "./ImportPayments.vue?vue&type=script&lang=js"
export * from "./ImportPayments.vue?vue&type=script&lang=js"
import style0 from "./ImportPayments.vue?vue&type=style&index=0&id=a0c64526&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c64526",
  null
  
)

export default component.exports